import { progressiveComponent } from 'site-modules/shared/components/progressive-component/progressive-component';
import { SeoAlsoViewedVehicles } from 'site-modules/core-page/components/seo-also-viewed-vehicles/seo-also-viewed-vehicles';

export default {
  /* Progressive Also Viewed */
  AlsoViewedVehiclesCrossShop: progressiveComponent({
    SEOComponent: SeoAlsoViewedVehicles,
    fullComponent: {
      loader: () =>
        import(/* webpackChunkName: "also-viewed" */ 'site-modules/shared/components/core-page/also-viewed-vehicles-cross-shop/also-viewed-vehicles-cross-shop'),
      name: 'AlsoViewedVehiclesCrossShop',
    },
    dataTrackingParent: 'edm-entry-also-viewed-vehicles',
  }),
};
